enum ImportModuleType {
  Program = 0
}
export default Object.freeze(ImportModuleType);
